import React from "react";
import { ArrowUpRight, BarChart3, Code2, LifeBuoy } from "lucide-react";
import Reveal from "./template/view.reveal";
import Tilt from "./template/view.tilt";
import { StoreBadges } from "./view.hero";

export function ViewCompany() {
    const points = [
        { icon: Code2, text: "Solutions digitales sur mesure" },
        { icon: BarChart3, text: "Analyse de données de santé" },
        { icon: LifeBuoy, text: "Support et amélioration continue" },
    ];
    return (
        <>
            <section className="py-24 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
                    <Reveal>
                        <p className="text-sm font-bold tracking-wider text-brand-600 uppercase">L'équipe</p>
                        <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight text-brand-950">Développé par SavanTech.</h2>
                        <p className="mt-5 text-lg text-slate-600 leading-relaxed">
                            Medic'help est conçu par SavanTech, une entreprise spécialisée dans les solutions numériques. Notre mission : rendre les soins plus accessibles, plus rapides et plus proches des patients, là où c'est le plus utile.
                        </p>
                        <a href="https://savantech.org" target="_blank" rel="noopener noreferrer"
                            className="mt-8 inline-flex items-center gap-2 bg-brand-500 text-white px-6 py-3.5 rounded-full font-bold hover:bg-brand-600 hover:-translate-y-0.5 transition-all shadow-[0_18px_36px_-14px_rgba(106,82,237,0.8)]">
                            Découvrir SavanTech <ArrowUpRight className="w-4 h-4" />
                        </a>
                    </Reveal>
                    <Reveal delay={120}>
                        <Tilt max={6} className="rounded-3xl p-8 bg-gradient-to-br from-[#f7f6fd] to-white border border-brand-100/70 shadow-[0_30px_60px_-34px_rgba(26,18,71,0.4)]">
                            <ul className="space-y-4">
                                {points.map(({ icon: Icon, text }) => (
                                    <li key={text} className="flex items-center gap-4 rounded-2xl bg-white p-4 border border-brand-100/60 tilt-pop">
                                        <span className="w-11 h-11 rounded-xl bg-brand-50 text-brand-600 flex items-center justify-center"><Icon className="w-5 h-5" /></span>
                                        <span className="font-semibold text-slate-800">{text}</span>
                                    </li>
                                ))}
                            </ul>
                        </Tilt>
                    </Reveal>
                </div>
            </section>

            <section id="download" className="px-4 sm:px-6 lg:px-8 pb-24 bg-white">
                <Reveal className="max-w-7xl mx-auto relative overflow-hidden rounded-[2rem] bg-gradient-to-br from-brand-500 via-brand-700 to-brand-950 text-white px-8 py-14 sm:px-14">
                    <div className="absolute inset-0 grain opacity-50" />
                    <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-fuchsia-400/25 blur-3xl" />
                    <div className="relative flex flex-col lg:flex-row lg:items-center justify-between gap-8">
                        <div>
                            <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight">Téléchargez Medic'help.</h2>
                            <p className="mt-3 text-white/75 max-w-lg">Créez votre compte en une minute et profitez de 3 mois de Premium offerts.</p>
                        </div>
                        <StoreBadges />
                    </div>
                </Reveal>
            </section>
        </>
    );
}
